import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Dashboard } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class DashboardModule extends VuexModule {
    @Action
    [Dashboard.getTotalOrderByLastMonth]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/dashboard/getTotalOrderByLastMonth`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Dashboard.getSentOrders](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/dashboard/getSentOrders`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Dashboard.getOrdersByLastMonth]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/dashboard/getOrdersByLastMonth`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Dashboard.getAmountTotalByProduct]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/dashboard/getAmountTotalByProduct`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}